import React, { useState, useEffect } from 'react'
import TransferenciasGlobaisApi from '../../services/robinhood/TransferenciasGlobaisApi';
import { Link } from 'react-router-dom';

export default function TransferenciasGlobaisAnos(props) {

    const [selecionado, setSelecionado] = useState(props.ano);
    const backgroundColor = props.backgroundColor ? props.backgroundColor : 'g-bg-cgreen';
    const demaisAnosUrl = props.demaisAnosUrl ? props.demaisAnosUrl : null;
    const downloadUrl = props.downloadUrl ? props.downloadUrl : null;
    const buttonLabel = props.buttonLabel ? props.buttonLabel : 'EXPORTAR PLANILHA';

    return (
        <>
            <section className="container-fluid">
                <div className="">
                    <p className="" style={{ marginBottom: '-0px', marginTop: '-15px', height: '35px' }}>
                        {props.retornar && props.retornar == true
                            && <Link to={'/extratos'} className={"btn btn-xs rounded  text-muted  m-b-5 m-r-5"}><i className='zmdi zmdi-undo'></i> VOLTAR </Link>}
                        {props.anos.map((ano, i) => {
                            return (
                                i < 5 &&
                                <span key={ano.ano} onClick={() => props.handlerAno(ano.ano)}
                                    className={ano.ano != props.ano ? "btn rounded  m-r-5 m-b-5 disabled" : `btn rounded ${backgroundColor} m-b-5 m-r-5`}
                                    style={{ fontSize: '12px', color: '', }}>
                                    <i className='zmdi zmdi-calendar p-r-5' style={{ fontSize: '' }}> </i>
                                    {ano.ano}
                                </span>
                            )
                        })}
                        {props.anos.length > 5 &&
                            <div className="btn-group rounded m-b-5 m-r-5">
                                <span className="btn rounded  dropdown-toggle text-muted" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ fontSize: '12px', marginTop: '-2px' }}> <i className='zmdi zmdi-calendar' style={{ fontSize: '', }}></i> ANOS ANTERIORES  <span className="caret"></span> </span>
                                <ul className="dropdown-menu">
                                    {props.anos.map((ano, i) =>
                                        i > 4
                                        && <li key={ano.ano} onClick={() => props.handlerAno(ano.ano)}>
                                            <a href="javascript:void(0);" className={ano.ano != props.ano ? "btn rounded  m-r-5 m-b-5" : `btn rounded ${backgroundColor} m-r-5 text-white`}>
                                                {ano.ano}
                                            </a>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        }
                        
                        {demaisAnosUrl && <a href={demaisAnosUrl} target='_blank' className={'btn rounded  m-r-5 m-b-5'}
                            style={{ fontSize: '', color: '', backgroundColor: '#EEEEEE' }}>
                            <i className='zmdi zmdi-link p-r-5 text-muted' style={{ fontSize: '' }}> </i>
                            <span className='text-muted'> DEMAIS ANOS </span>
                        </a>}
                        {downloadUrl && <a href={downloadUrl} target='_blank' className={'btn rounded  m-r-5 m-b-5'}
                            style={{ fontSize: '12px', backgroundColor: '#EEEEEE' }}>
                            <i className='zmdi zmdi-border-all p-r-5 text-success' style={{ fontSize: '' }}> </i>
                            <span className='text-muted'> {buttonLabel} </span>
                        </a>}
                    </p>
                    <br />
                </div>
            </section >
        </>
    );
}
